module.exports = __webpack_public_path__ + "img/banner-3.856be475.png";